import React from 'react';
import './mCalendarLegendComponent.css';
import scheduleUtils from '../../../scheduleUtils';
const MCalendarLegendComponent = (props) => {
  return (
    <div
      className={`et-n-events-agenda-status-madal-show-wrap ${
        props.showBothAgendaAndEventsTab
          ? 'et-n-events-agenda-status-madal-mid'
          : ''
      }`}>
      {Object.values(scheduleUtils.meetingStatuses).map((item, index) => {
        return (
          <div
            key={index}
            className="et-n-events-agenda-madal-color-meeting-status-wrap">
            <div
              className={`et-n-events-agenda-status-${item.status.toLowerCase()}-show`}></div>
            <div className="et-n-events-agenda-status-modal-content">
              <div className="et-n-events-agenda-status-madal-text">
                {item.title}
              </div>
              <div className="et-n-events-agenda-status-madal-description">
                {item.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MCalendarLegendComponent;
